import { createFilter } from './BaseFilter';

export const createToggleFilter = ({ field, label, predicate }) => {
    return createFilter({
        type: 'toggle',
        field,
        label,

        getInitialState: () => ({
            value: false,
            isActive: false
        }),

        applyFilter: (data, currentValue) => {
            if (currentValue === false) return data;

            return data.filter(item => predicate(item));
        },

        renderFilter: ({ value, onChange }) => {
            return (
                <div style={{ minWidth: '150px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                    <label className="form-label mb-2" htmlFor={`toggle-${field}`}>{label}</label>
                    <div style={{ height: '38px', display: 'flex', alignItems: 'center' }}>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                style={{
                                    width: '4em',
                                    height: '2em',
                                    marginRight: '0.5em',
                                    cursor: 'pointer'
                                }}
                                type="checkbox"
                                id={`toggle-${field}`}
                                checked={value}
                                onChange={(e) => onChange(e.target.checked)}
                            />
                        </div>
                    </div>
                </div>
            );
        },

        reset: () => false
    });
};
